// THE BUSINESS-SETTINGS TAB SUFFIXES — one table, one function, two callers.
//
// Every settings URL is `currentAccount.settingsPath` (backend-served) plus one of these fixed
// suffixes. AccountSettingsNav builds its tab hrefs with it; AccountSwitcher uses it to land the
// operator on the SAME tab in the business they just switched to. A second copy would mean a tab
// that exists in the nav but that the switcher cannot follow.
//
// Mirrors AccountSettingsChrome::SETTINGS_SECTIONS on the backend, which is the authority on which
// section a given action belongs to.
import type { AccountSettingsSection } from '@/types/shared'

const ACCOUNT_SETTINGS_SUFFIX: Record<AccountSettingsSection, string> = {
  overview: '',
  team: '/team',
  groups: '/groups',
  'pms-connections': '/pms-connections',
  billing: '/billing',
  activity: '/activity',
}

/**
 * The path of one settings tab inside a given business. `settingsPath` must be that business's own
 * (`currentAccount.settingsPath`, or an `AccountPropertyGroup.settingsPath` when pointing at
 * another business) — this function only ever appends.
 */
export function accountSettingsPath(settingsPath: string, section: AccountSettingsSection): string {
  return `${settingsPath}${ACCOUNT_SETTINGS_SUFFIX[section]}`
}
